import { HotelReservedCardFooterTypesPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer/hotel-reserved-card-footer.types";
import { useJwtToken } from "@website/hooks/auth-manager";
import { isInvalidCheckin } from "@website/utils/date-format";
import { useLoginModal } from "@website/widget/login";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";

export const useHotelReserveCardFooter = ({
  id,
  onClick,
  onModalClose,
  roomCount,
  setRoomCount
}: HotelReservedCardFooterTypesPropertiesType) => {
  const router = useRouter();
  const { onLoginModalOpen } = useLoginModal();
  const { phoneNumber } = useJwtToken();

  const [roomSelect, setRoomSelect] = useState<number | string>();
  const [loading, setLoading] = useState<boolean>(false);

  const isInvalid = isInvalidCheckin(
    router.query.date_from,
    router.query.date_to,
    false
  );
  const openDatePicker = useCallback(() => {
    const search_date_range = document.querySelector<HTMLDivElement>(
      `[data-testid="search_date_range"]`
    );
    search_date_range?.scrollIntoView({ block: "center" });
    search_date_range?.click();
    setTimeout(() => {
      const datePickerInput = document.querySelector<HTMLInputElement>(
        `[data-testid="date_picker_start_input"]`
      );
      datePickerInput?.click();
    }, 200);
  }, []);

  const createBook = useCallback(() => {
    if (isInvalid) {
      onModalClose?.(false);
      openDatePicker();
    } else {
      setRoomSelect(id);
      setLoading(true);
      onClick?.()?.finally?.(() => setLoading(false));
    }
  }, [id, isInvalid, onClick, openDatePicker]);

  const onHandleClick = useCallback(() => {
    if (!phoneNumber) {
      return onLoginModalOpen().then(() => createBook());
    }
    createBook();
  }, [createBook, phoneNumber]);

  const handleRoomCount = useCallback(
    (count: number) => {
      setRoomCount(count);
      return router.replace(
        {
          pathname: router.pathname,
          query: {
            ...router.query,
            no_rooms: count
          }
        },
        undefined,
        { scroll: false, shallow: true }
      );
    },
    [router]
  );

  const handleRecommendedHotel = useCallback(
    () =>
      document
        .querySelector("#hotel_recomendation")
        ?.scrollIntoView({ block: "center" }),
    []
  );

  return {
    roomCount,
    roomSelect,
    loading,
    setRoomCount: handleRoomCount,
    onHandleClick,
    openDatePicker,
    handleRecommendedHotel
  };
};
